import nxModule from 'nxModule';
import {AttachedFile} from '../../service/file.service';
import {Loan} from '../../service/loan.types';
import {PageRequest, PageResult} from "tools/HttpTypes";

interface PreterminationBatchFile {
  id: number;
  fileId: number;
  officialReceipt?: string;
  startingReceiptNumber?: string;
  remarks?: string;
  uploadedOn: string;
  uploadedBy: number;
}

export interface PreterminationBatchFileOutput {
  loanBatchFile: PreterminationBatchFile;
  file: AttachedFile;
  rowCount: number;
  errorsCount: number;
}

interface PreterminationBatchFilePayment {
  id:              number;
  lineNo:          number;
  batchFileId:     number;
  loanId:          number;
  officialReceipt: string;
  amount:          number;
}

export interface PreterminationBatchFilePaymentsOutput {
  payment: PreterminationBatchFilePayment;
  loan: Loan;
  customerName: string;
  principal?: number;
  interest?: number;
  penalty?: number;
  pastDueInterest?: number;
}

export class BatchLoanPreterminationService {
  constructor(private http: any) { }

  readPreterminationBatchFilesOutput(pageRequest: PageRequest): Promise<PageResult<PreterminationBatchFileOutput>> {
    return this.http.get(`/products/loans/pretermination-batch-files?pageNo=${pageRequest.pageNo}&pageSize=${pageRequest.pageSize}`).toPromise();
  }
}

nxModule.service('batchLoanPreterminationService', BatchLoanPreterminationService);
